import { TFunction } from 'i18next';
import { WarningModalProps } from '@/components/Ad/WarningModal/WarningModal';

export const popupData = (
  t: TFunction,
  popupToggle: () => void,
  isUnblocking: boolean,
  unblock: () => Promise<void>
): Record<
  'blockedByYou' | 'blockedByOtherUser',
  Omit<WarningModalProps, 'isOpen' | 'onClose'>
> => {
  return {
    blockedByYou: {
      title: t('pages.ad.you_blocked_user'),
      description: t('pages.ad.unblock_to_continue'),
      actions: {
        left: {
          text: t('common.deny'),
          onClick: popupToggle,
          disabled: isUnblocking,
        },
        right: {
          text: t('common.unblock'),
          onClick: unblock,
          disabled: isUnblocking,
        },
      },
    },
    blockedByOtherUser: {
      title: t('pages.ad.user_unavailable'),
      description: t('pages.ad.user_restricts_access'),
    },
  };
};
